import {
    HStack,
    Box,
    ContextMenuSub,
    ContextMenuSubContent,
    ContextMenuSubTrigger,
} from '@cad-arc';
import { PillUnit } from '@mark43/cad-api';
import React from 'react';
import { UnitPill } from '../common/components/unit-pill';
import { ErrorBoundary } from '../monitoring/error-boundary';
import { UnitContextMenu } from './unit-context-menu';

export function MultiUnitContextMenu({ data }: { data: PillUnit[] }): React.ReactElement {
    const items = data.map((pillUnit) => (
        <ContextMenuSub key={pillUnit.id}>
            <ContextMenuSubTrigger>
                <HStack maxWidth={160}>
                    <UnitPill unit={pillUnit} />
                    <Box
                        flexShrink={10}
                        whiteSpace="nowrap"
                        textOverflow="ellipsis"
                        overflow="hidden"
                        minWidth={0}
                    >
                        {pillUnit.tip}
                    </Box>
                </HStack>
            </ContextMenuSubTrigger>
            <ContextMenuSubContent>
                <UnitContextMenu unitId={pillUnit.id} />
            </ContextMenuSubContent>
        </ContextMenuSub>
    ));
    return (
        <ErrorBoundary
            name="MULTI_UNIT_CONTEXT_MENU"
            messageVerbNoun="opening the unit menu"
            asToast={true}
        >
            {items}
        </ErrorBoundary>
    );
}
